import { render, staticRenderFns } from "./SyncHistory.vue?vue&type=template&id=f87cac64&scoped=true&"
import script from "./SyncHistory.vue?vue&type=script&lang=js&"
export * from "./SyncHistory.vue?vue&type=script&lang=js&"
import style0 from "./SyncHistory.vue?vue&type=style&index=0&id=f87cac64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87cac64",
  null
  
)

export default component.exports